import { AbstractControl, ValidationErrors } from '@angular/forms';
import { isDate } from '../utils';

export const date = (control: AbstractControl): ValidationErrors | null => {
  const key = 'date';

  const value = control.value;

  if (!value) return null;

  if (!isDate(value)) return { [key]: true };

  return null;
};
